import { Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import StickyImagePageLayout from "common/StickyImagePageLayout"
import { StyledFlexBoxRow } from "components/searchAmot/SearchAmotPage"
import { useTranslations } from "next-intl"
import Image from "next/image"
import styled from "styled-components"
import { ContactPage } from "../../api"
import Description from "../../common/Description"
import ContactFormIframe from "./ContactFormIframe"
//Styles

const StyledContent = styled.div`
  padding-top: 50px;
`

const StyledFormWrapper = styled.div`
  padding: 15px;
  border: 1px solid ${(p) => p.theme.colors.activitiesBorder};
  border-radius: 15px;
  margin-bottom: 60px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 19px 30px 0px;
  }
`
const StyledContentWrapper = styled.div`
  padding: 0 16px;
  margin-top: 30px;
  margin-bottom: 30px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 0;
  }
`
const StyledDescription = styled(Typography).attrs({
  component: "p",
  variant: "body1",
})`
  margin-bottom: 20px;
  margin-top: 0;
  font-size: 14px;
  color: ${(p) => p.theme.colors.black};
`
//Types
interface IContactUsPage {
  data: ContactPage
}

const ContactUsPage = ({ data }: IContactUsPage) => {
  const t = useTranslations("contactForm")
  const isDesktop = useIsDesktop()
  const image = isDesktop ? data.contact?.logoDesktop : data.contact?.logoMobile
  const poster = isDesktop
    ? data.poster?.posterDesktop
    : data.poster?.posterMobile
  //Render
  return (
    <>
      <StickyImagePageLayout
        imageUrl={image?.media?.publicUrl}
        altText={image?.media?.altText}
        type={image?.media?.type}
        poster={poster?.media?.publicUrl}
      >
        <StyledContent>
          <Description
            data={{
              title: data?.navigationTitle,
              // subtitle: data?.metaDescription,
              description: data?.contact?.shortDescription?.value,
            }}
          />
          <StyledContentWrapper>
            <StyledDescription>
              {t("address")} {data?.contact?.address?.value}
            </StyledDescription>
            <StyledDescription>
              {t("parking")} {data?.contact?.parkingLot?.value}
            </StyledDescription>
            <StyledFlexBoxRow $gap="12px" $align="self-start">
              <a href={`mailto:${data?.contact?.email?.value}`}>
                <Image
                  src="/emailIcon.svg"
                  alt="emailIcon"
                  width={17}
                  height={17}
                />
              </a>
              <a href={`mailto:${data?.contact?.email?.value}`}>
                <StyledDescription>
                  {data?.contact?.email?.value}
                </StyledDescription>
              </a>
            </StyledFlexBoxRow>
            <StyledFlexBoxRow $gap="12px" $align="self-start">
              <a href={`tel:${data?.contact?.phoneNumber?.value}`}>
                <Image
                  src="/phoneIcon.svg"
                  alt="phoneIcon"
                  width={17}
                  height={17}
                />
              </a>
              <a href={`tel:${data?.contact?.phoneNumber?.value}`}>
                <StyledDescription style={{ direction: "ltr" }}>
                  {data?.contact?.phoneNumber?.value}
                </StyledDescription>
              </a>
            </StyledFlexBoxRow>
          </StyledContentWrapper>
          <StyledFormWrapper>
            <ContactFormIframe withCompany={true} generalMessage />
          </StyledFormWrapper>
        </StyledContent>
      </StickyImagePageLayout>
    </>
  )
}

export default ContactUsPage
